export default function () {
  this.loadFaqs()
}
